import Vue from 'vue'
import ApiUrls from "@/api/apiUrls";
import axios from '@/api/axios'

axios.install(Vue)

export default {
  install(Vue, options) {
    //过滤重复数组
    Vue.prototype.$unique = function (arr1,flag) {
      const res = new Map();
      return arr1.filter((a) => !res.has(a[flag]) && res.set(a[flag], 1))
    },
    Vue.prototype.$browserType=function() {


      var isMobile = window.navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      ); // 是否手机端
      var isWx = /micromessenger/i.test(navigator.userAgent); // 是否微信
      var isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
      var isApp = /Macintosh/i.test(navigator.userAgent); // 是否iPad-app
      var PCFlag = 0;

      if (isComWx && isMobile) {
          //手机端企业微信，ipad企业微信，android企业微信
          PCFlag = 1;
      } else if (isComWx && !isMobile) {
          //PC端企业微信
          PCFlag = 2;
      } else if (isWx && isMobile) {
          // 手机端微信
          PCFlag = 3;
      } else if (isWx && !isMobile) {
          // PC端微信
          PCFlag = 4;
      } else if (isMobile) {
        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
          console.log('Safari')
          PCFlag = 3
        }else{
          PCFlag = 5;
        }
      } else if (isApp) {
          PCFlag = 6;
      }
      return PCFlag;
    },
    Vue.prototype.$getCurrentDate=function(date) {
      var y =  date.getFullYear();
      var m = date.getMonth()+1;
      var d = date.getDate();
      var h = date.getHours();
      var min = date.getMinutes();
      var s = date.getSeconds();
      var str=y+'-'+(m<10?('0'+m):m)+'-'+(d<10?('0'+d):d)
      return str;
    },
    //时间戳转年月日
    Vue.prototype.$TimeStampToDate=function(timestamp,flag) {
      // console.log(timestamp,'timestamp')
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear();
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
      var D = date.getDate()< 10?('0'+date.getDate()):date.getDate();
      var h = date.getHours() + ':';
      var m = date.getMinutes() + ':';
      var s = date.getSeconds();
      let result=""
      if(flag=='yyyy-MM'){
        result=Y+'-'+M
      }else if(flag=='chineseYearMonth'){
        result=Y+'年'+M+'月'
      }else{
        result=Y+'-'+M+'-'+D
      }
      return result
    },
    Vue.prototype.$dateCompare= function(time,time1,time2){
      var date = Date.parse(new Date(time.replace(/-/g, '/')));
      var date1 = Date.parse(new Date(time1.replace(/-/g, '/')));
      var date2 = Date.parse(new Date(time2.replace(/-/g, '/')));
      if (date1<=date&&date<=date2) {
          return true;
      };
      return false;
    },
    Vue.prototype.$isAssetTypeAnImage=function(fileName) {
      var type = fileName.substring(fileName.lastIndexOf('.') + 1);
      return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].includes(type.toLowerCase());
    },
    Vue.prototype.$getSystemLanguage=function() {
  let userAgentInfo = navigator.userAgent;
  let languageInfo = navigator.language;
  console.log(userAgentInfo.indexOf('Language'), languageInfo.indexOf('en'), 'userAgentInfo')
  if (userAgentInfo.indexOf('Language') > -1) {
    if (userAgentInfo.indexOf('Language/en') > -1) {
      return 'en-GB';
    } else {
      return 'zh-CN';
    }
  } else if (languageInfo.indexOf('en') > -1) {
    return 'en-GB';
  } else {
    return 'zh-CN';
  }
}
    Vue.prototype.$showPreview = function(filepath, fileName) {
      //查看是否是图片
      if (this.$isAssetTypeAnImage(fileName)) {
          console.log(filepath, '图片');
          cs.playImageFile(filepath, fileName, function (result) {
              if (result.state != 1) {
              }
          });
      } else {
          console.log(filepath, '文件');
          cs.playOfficeFile(filepath, fileName, function (result) {
              if (result.state != 1) {
              }
          });
      }
    },
    //认证中心检查账号状态
    Vue.prototype.$CheckStatus = function (query,path) {
      console.log("CheckStatus");
      console.log('传入url', query, path,this.$browserType(),process.env.NODE_ENV)
      let that = this
      return new Promise(async function (resolve, reject) {
        //费森app登录，cs获取用户信息
        if (that.$browserType() > 4 && process.env.NODE_ENV === 'production') {
          cs.getUserInfo((result) => {
            if (result.state == 1) {
              console.log(result.result)
              var data = result.result;
              localStorage.setItem('language', data.Language)
              that.$i18n.locale = data.Language
              try {
                that.$GetUserInfo(data.ADName).then(res => {
                  resolve()
                }).catch(err => {
                  console.log(err,'GetUserInfo-error')
                  reject(err)
                })
              } catch (error) {
                console.log(error,'try-error')
                reject(error)
              }
            }
          });
          return
        }
        if (query.code && query.code != 'undefined') {
          if(localStorage.getItem('onAuthAppCode')==''){
            that.$GetToken(query).then(res => {
              resolve()
            }).catch(err=>{
              reject(err)
            })
          }else{
            resolve()
          }
        } else {
          let res1 = await that.$reqPost(ApiUrls.LOGIN_GETLOGINURL+`?redirectUrl=${encodeURIComponent(path)}`, {}, { loading: true })
          window.location.replace(res1)
        }
      })
    },
    //去重
    Vue.prototype.$Unique = function(arr1,flag) {
      const res = new Map();
      return arr1.filter((a) => !res.has(a[flag]) && res.set(a[flag], 1))
    },
    Vue.prototype.$ReplaceUrlParam=function(url, paramName, paramValue) {
      const pattern = new RegExp('(' + paramName + '=).*?(&|$)');
      const testResult = url.match(pattern);
      if (testResult) {
        const modified = url.replace(pattern, '$1' + paramValue + '$2');
        return modified;
      }
      const separator = (url.indexOf('?') !== -1) ? '&' : '?';
      return url + separator + paramName + '=' + paramValue;
    },
    //获取token
    Vue.prototype.$GetToken = function (query) {
      let that = this
      let addUrl = "?Code=" + query.code + "&State=" + query.state + "&CompanyCode=" + query.company + "&Language=" + query.language
      return new Promise(function (resolve, reject) {
        try {
          that.$reqLogin(ApiUrls.AUTH_TOKEN + addUrl, {
            username: "",
            password: "",
            grant_type: "password",
            CompanyCode: "000",
          }).then((res) => {
            console.log(res,'reqLogin',query)
            // if (res.res_code == 6000) {
              localStorage.setItem('language', query.language)
              localStorage.setItem('onAuthAppCode', query.code)
              window.localStorage.setItem('token',res.authLoginToken)
              window.localStorage.setItem('UserName',res.LoginName)
              window.localStorage.setItem('UserId',res.MDMUserID)
              that.$i18n.locale = query.language
              resolve()
            // }else{
            // }
          }).catch((error) => {
            reject(error)
          })
        } catch (error) {
          console.log(error,'try')
        }
      })
    },
    Vue.prototype.$GetUserInfo = function(username){
      let str=this.$getCurrentDate(new Date()).replace(/[^0-9]/ig,"")
      let postData={
          username: username,
          password: this.$md5(str),
          company: "",
          language: "",
          grant_type: "password",
      }
      let that = this
        return new Promise(function (resolve, reject) {
          that.$reqLogin(ApiUrls.AUTH_TOKEN, postData, { showLoading: true }).then(res => {
            if (res.res_code == 6000) {
              window.localStorage.setItem('token',res.access_token)
              window.localStorage.setItem('ChineseName',res.ChineseName)
              window.localStorage.setItem('LoginName',res.LoginName)
              window.localStorage.setItem('CompanyCode',res.CompanyCode)
              window.localStorage.setItem('UserName',res.LoginName)
              window.localStorage.setItem('UserId',res.UserId)
              window.localStorage.setItem('BuCode',res.BuCode)
              resolve(res)
            }
          }).catch((error) => {
            reject(error)
          })
        })
    },
    //获取档期系统语言
    Vue.prototype.$GetSystemLanguage = function () {
      let userAgentInfo = navigator.userAgent;
      let languageInfo = navigator.language;
      console.log(userAgentInfo.indexOf('Language'), languageInfo.indexOf('en'), 'userAgentInfo')
      if (userAgentInfo.indexOf('Language') > -1) {
        if (userAgentInfo.indexOf('Language/en') > -1) {
          return 'en-GB';
        } else {
          return 'zh-CN';
        }
      } else if (languageInfo.indexOf('en') > -1) {
        return 'en-GB';
      } else {
        return 'zh-CN';
      }
    },
    Vue.prototype.$OpenUrl=function(url) {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

      try { 
        if (isAndroid) {
          //android终端
          cs.openWebView(url);
        } else if (isiOS) {
          //ios终端
          cs.openWebView(url);
        } else {
          window.location.href = url;
        }
      } catch (e) { 
        window.location.href = url;
      }
  }

    Vue.prototype.$isData=function(data) {
      return (data == null || data == undefined || data == 'undefined' || data == '' || data == "[]" || data == '00000000-0000-0000-0000-000000000000') ? false : true;
     },
    Vue.prototype.$getLocal=function(objName){
      if (!this.$isData(objName))
        return '';

      var storage = window.localStorage;
      var result = this.$isData(storage) ? storage.getItem(objName) : '';
      return this.$isData(result) ? result : '';
    },
    Vue.prototype.$setLocal=function(objName, objValue){
      // if (!isData(objName))
      //     return;
      var storage = window.localStorage;
      // if (isData(storage))
      storage.setItem(objName, objValue);
  }
    //去除空格
    Vue.prototype.trim = function (str, flag) {
      if (flag == 0) {
        return str.replace(/^[" "||"　"]*/, "").replace(/[" "|"　"]*$/, "");// 去除头和尾
      } else if (flag == 1) {
        return str.replace(/\s/g, '');//去除所有空格
      } else if (flag == 2) {
        return str.replace(/(\s*$)/g, "");//去除右边所有空格
      }
    },

      //年月份转标准时间
      Vue.prototype.GetStandardDate = function (date) {
        var arr = date.split("-")
        return new Date(arr[0], (parseInt(arr[1], 10) - 1), arr[2])
      },
      //数组去重
      Vue.prototype.uniqueArray = function (arr) {
        return [...new Set(arr)]
      },

      //判断数据类型
      //dataType('2')   //String
      //dataType(['2'])   //Array
      //dataType({})   //Object
      Vue.prototype.dataType = function (data) {
        var type = Object.prototype.toString.call(data);
        type = type.substring(1, type.length - 1)
        return type.split(" ")[1];
      },

      //判断是否是微信浏览器
      Array.prototype.isWeiXin = function () {
        var ua = navigator.userAgent.toLowerCase();
        return ua.match(/microMessenger/i) == 'micromessenger'
      },
      //去除html标签
      Array.prototype.removeHtmltag = function (str) {
        return str.replace(/<[^>]+>/g, '')
      },

      //随机数
      Array.prototype.RandomNumber = function () {
        var a = Math.random, b = parseInt;
        return Number(new Date()).toString() + b(10 * a()) + b(10 * a()) + b(10 * a());
      },

      //全局遮罩
      Vue.prototype.openLoading = function () {
        const loading = this.$toast.loading({
          message: '',
          forbidClick: true,
        });
        return loading
      },
      Vue.prototype.$downFile = function (res,fileName,fileType) {
        console.log("全局导出", res,fileType)
        //  res.headers['content-disposition']='content-disposition: "attachment; filename=_______20230816120106.xlsx; filename*=UTF-8%E9%A1%B9%E7%9B%AE%E5%AE%89%E5%85%A8%E6%8A%A5%E8%A1%A8_20230816120106.xlsx'
        //  attachment; filename=\"=utf-8?B?6aG555uu5a6J5YW05og6KGOXZIWM-MWODE2NTAX0DA1Lnhsc3e=?=\"
        //  content-disposition: "attachment; filename=_______20230816120106.xlsx; filename*=UTF-8''%E9%A1%B9%E7%9B%AE%E5%AE%89%E5%85%A8%E6%8A%A5%E8%A1%A8_20230816120106.xlsx
        var fileName = res.headers['content-disposition']
        let fileNameIndex = fileName.indexOf('utf-8?B?')
        if (fileNameIndex != -1) {
          fileName = fileName.substr(fileNameIndex + 8)
          fileName = Base64.decode(fileName)//解码后的文件名
        } else {
          fileName = fileName.substr(fileName.indexOf('filename=') + 9)
        }
        var content = res.data
        var csvData = new Blob([content], { type: 'text/csv' })
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(csvData, fileName)
        }
        else {
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.style = 'display: none'
          var url = window.URL.createObjectURL(csvData)
          a.href = url
          a.download = fileName
          a.click()
          a.remove()
          window.URL.revokeObjectURL(url)
        }
      }
  }
}
